import { Component } from '@angular/core';
import { UtilsTabsComponent } from '../../components/utils-tabs/utils-tabs.component';

@Component({
  selector: 'app-containers',
  standalone: true,
  templateUrl: './containers.component.html',
  imports: [UtilsTabsComponent],
  styleUrl: './containers.component.scss'
})
export class ContainersComponent {}
